import React, { useState } from "react";
import styled from "styled-components";
import close from "../Assets/Close.png";
import Button from "./Button";
import { zIndex } from "../config/zIndex";

// Styled Components
const ModalOverlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: ${zIndex.appHeader};
	display: flex;
	align-items: center;
	justify-content: center;
`;

const ModalBackdrop = styled.div`
	position: absolute;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	max-width: 90%;
	border-radius: 10px;
	z-index: ${zIndex.aboveHeader};
	overflow-x: hidden;
`;

const ModalHeader = styled.div`
    color:#FFF;
    background: rgba(45, 35, 66, 0.8);
	padding: 1rem 1.5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const ModalTitle = styled.h2`
	font-size: 1.25rem;
	font-weight: 600;
`;

const CloseButton = styled.button`
	color: #6b7280;
	transition: color 0.2s ease;
    background: transparent;
    outline: none;
    border: none;
	&:hover {
		color: #374151;
	}
`;

const ModalContent = styled.div`
	padding: 1.5rem;
	overflow-y: auto;
	max-height: 70vh;
    background: #f2f2f2;
`;

// Modal Component
const Modal = ({ isOpen, onClose, title, children }) => {
	if (!isOpen) return null;

	return (
		<ModalOverlay>
			<ModalBackdrop onClick={onClose} />

			<ModalContainer>
				<ModalHeader>
					<ModalTitle>{title}</ModalTitle>
					<CloseButton onClick={onClose} aria-label="Close modal">
						<img
							src={close}
							alt="close"
							style={{
								height: "30px",
								filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
							}}
						/>
					</CloseButton>
				</ModalHeader>

				<ModalContent className="no-scrollbar" >{children}</ModalContent>
			</ModalContainer>
		</ModalOverlay>
	);
};

// Modal Button Component
const ModalButton = ({ disabled = false, buttonText = "Open Modal", title = "Modal Title", render }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	return (
		<>
			<Button disabled={disabled} onClick={openModal}>{buttonText}</Button>

			<Modal isOpen={isModalOpen} onClose={closeModal} title={title}>
				{ render && render({ closeModal }) }
			</Modal>
		</>
	);
};

export default ModalButton
